// Blog pages render these labels in the browser. Keep them separate from
// blog.server.js, whose fs and gray-matter imports read posts from disk.
export const REGION_LABELS = {
  ca: "Canada",
  au: "Australia",
  nz: "New Zealand",
};
